import { render, staticRenderFns } from "./fccCadastroDescricoes.vue?vue&type=template&id=1c094d72"
import script from "./fccCadastroDescricoes.vue?vue&type=script&lang=js"
export * from "./fccCadastroDescricoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports